// extracted by css-extract-rspack-plugin
export default {"budgetSidebarRoot":"cjTkRo"};